const currency = (() => {
	// v.0.07
	const codes = {
		'AUD': {
			'symbol': 'AU$',
			'name': 'Australian Dollar'
		},
		'CAD': {
			'symbol': 'CA$',
			'name': 'Canadian Dollar'
		},
		'EUR': {
			'symbol': '€',
			'name': 'Euro'
		},
		'GBP': {
			'symbol': '£',
			'name': 'British Pound'
		},
		'USD': {
			'symbol': 'US$',
			'name': 'United States Dollar'
		},
		'BRL': {
			'symbol': 'R$',
			'name': 'Brazilian Real'
		},
		'CHF': {
			'symbol': 'CHF',
			'name': 'Swiss Franc'
		},
		'CNY': {
			'symbol': 'CNY',
			'name': 'Chinese Renminbi Yuan'
		},
		'CZK': {
			'symbol': 'CZK',
			'name': 'Czech Koruna'
		},
		'DKK': {
			'symbol': 'DKK',
			'name': 'Danish Krone'
		},
		'HKD': {
			'symbol': 'HKD',
			'name': 'Hong Kong Dollar'
		},
		'IDR': {
			'symbol': 'Rp',
			'name': 'Indonesias Rupiah'
		},
		'ILS': {
			'symbol': '₪',
			'name': 'Czech Koruna'
		},
		'INR': {
			'symbol': 'Rs.',
			'name': 'Indian Rupee'
		},
		'JPY': {
			'symbol': '¥',
			'name': 'Japanese Yen'
		},
		'KRW': {
			'symbol': 'KRW',
			'name': 'South Korean Won'
		},
		'MXN': {
			'symbol': 'MXN',
			'name': 'Mexican Peso'
		},
		'MYR': {
			'symbol': 'MYR',
			'name': 'Malasyan Ringgit'
		},
		'NOK': {
			'symbol': 'NOK',
			'name': 'Norwegian Kroner'
		},
		'NZD': {
			'symbol': 'NZD',
			'name': 'New Zealand Dollar'
		},
		'PHP': {
			'symbol': 'PHP',
			'name': 'Philippine Peso'
		},
		'PLN': {
			'symbol': 'PLN',
			'name': 'Polish Złoty'
		},
		'RUB': {
			'symbol': 'RUB',
			'name': 'Russian Ruble'
		},
		'SEK': {
			'symbol': 'SEK',
			'name': 'Swedish Krona'
		},
		'SGD': {
			'symbol': 'S$',
			'name': 'Singapore Dollar'
		},
		'THB': {
			'symbol': 'THB',
			'name': 'Thai Baht'
		},
		'TRY': {
			'symbol': 'TRY',
			'name': 'Turkish Lira'
		},
		'ZAR': {
			'symbol': 'ZAR',
			'name': 'South Africa, Rand'
		}
	}
	return {
		/*
		 * @method format
		 * @method delimiter
		 * @method convert
		 */


		/**
		 * @param { Number } amount
		 * @param { String } currencyCode
		 * @param { String } languageCode ('EN', 'Nl'...)
		 * @param { Boolean } includeCents
		 */

		format: (amount = 0, currencyCode = 'EUR', languageCode = 'EN', includeCents = true) => {
			return `${codes[currencyCode].symbol} ${currency.delimiter(amount, includeCents)}`;
		},

		/**
		 * @param { Number } amount
		 * @param { Boolean } includeCents
		 */

		delimiter: (amount, includeCents) => {
			let delimiter = '.';
			let num = amount.toString();
			let whole = num.substring(0, num.length - 2) || 0;
			let cents = num.substr(-2);

			if (includeCents) {
				if (whole != 0) {
					whole = whole.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
				}

				return whole + delimiter + cents;
			}
			else {
				if (cents != 0) {
					return whole + delimiter + cents;
				}

				return whole;
			}
		},

		/**
		 * @param { Number } from currency amount
		 * @param { String } currency string (USD, EUR etc).
		 * @param { String } currency string (USD, EUR etc)
		 * @param { String } default to empty, use 'ADD' to add markup or 'SUB' to subtract
		 *
		 */

		convert: (amount, from, to, markup) => {
			return new Promise(async (resolve, reject) => {
				let query = `?amount=${amount}&from=${from}&to=${to}`;

				if (markup) {
					query += `&markup=${markup}`;
				}

				const params = {
					credentials: 'same-origin',
					method: 'GET',
					headers: {
						'Accept': 'application/json',
						'Content-Type': 'application/json',
						'X-Requested-With': 'XMLHttpRequest'
					}
				}

				try {
					const response = await fetch(`/json/currency/convert/${query}`, params);
					const data = await response.json();
					if (data.ok === false) {
						throw Error(data.error);
					}

					resolve(data);
				} catch (error) {
					reject(error);
				}
			});
		},
		convertAndFormat: (amount, from, to, markup) => {
			return new Promise((resolve, reject) => {
				let query = `?amount=${amount}&from=${from}&to=${to}`;

				if (markup) {
					query += `&markup=${markup}`;
				}

				const params = {
					credentials: 'same-origin',
					method: 'GET',
					headers: {
						'Accept': 'application/json',
						'Content-Type': 'application/json',
						'X-Requested-With': 'XMLHttpRequest'
					}
				}

				return fetch(`/json/currency/convert/${query}`, params)
				.then(response => {
					return response.json();
				})
				.then(response => {

					if (response.ok === false) {
						throw Error(response.error);
					}

					let data = currency.format(response.to.amount, response.to.currency, 'EN');
					resolve(data);
				})
				.catch(error => {
					console.error(error);
				});
			});
		}
	}
})();
